import * as iso2iso3_data from './iso2iso3.json';

export const iso2toiso3 = (iso2) => {
  return iso2iso3_data.default.find((el) => el.iso2.localeCompare(iso2) === 0)?.iso3.toLowerCase();
};
